import { NgFor } from '@angular/common';
import { Component, inject } from '@angular/core';
import { FormControl, FormGroup, Validators, ReactiveFormsModule } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatFormField, MatLabel } from '@angular/material/form-field';
import { MatSelect, MatOption } from '@angular/material/select';
import {
  AbstractDialogResultData,
  AbstractFormDialog,
  AbstractFormDialogData,
  FormDialogComponent,
} from '@next/core-lib/dialog';
import { LocaleService, TranslatePipe } from '@next/core-lib/i18n';

export interface RefValSheetCountryDialogInputData extends AbstractFormDialogData {
  countries: string[];
}

export interface RefValSheetCountryDialogResultData {
  country: string;
}
@Component({
  selector: 'app-reference-value-sheet-country-dialog',
  templateUrl: './reference-value-sheet-country-dialog.component.html',
  imports: [
    FormDialogComponent,
    ReactiveFormsModule,
    MatFormField,
    MatLabel,
    MatSelect,
    NgFor,
    MatOption,
    TranslatePipe,
  ],
})
export class ReferenceValueSheetCountryDialogComponent extends AbstractFormDialog<RefValSheetCountryDialogResultData> {
  data = inject<RefValSheetCountryDialogInputData>(MAT_DIALOG_DATA);
  protected mdDialogRef =
    inject<
      MatDialogRef<
        ReferenceValueSheetCountryDialogComponent,
        AbstractDialogResultData<RefValSheetCountryDialogResultData>
      >
    >(MatDialogRef);
  private readonly locale = inject(LocaleService);

  formGroup: FormGroup;

  /** Inserted by Angular inject() migration for backwards compatibility */
  constructor(...args: unknown[]);

  constructor() {
    super();

    this.data.title = this.locale.translate('reference-value-sheet.select-country.title');

    this.formGroup = new FormGroup({
      country: new FormControl(null, [Validators.required]),
    });
  }

  getRefValSheetCountryLabel(country: string) {
    return this.locale.translate('countries.' + country);
  }

  save(): void {
    this.confirm({ country: this.formGroup.value.country });
  }
}
